export enum CertificateAffiliation {
  PRODUCT = 'PRODUCT',
  COMPANY = 'COMPANY'
}
